import { useEffect, useState } from 'react';

interface Props {
  onAnalysisClick: () => void;
}

const StarIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
  </svg>
);

export default function StickyBar({ onAnalysisClick }: Props) {
  const [footerVisible, setFooterVisible] = useState(false);

  useEffect(() => {
    const footer = document.querySelector('footer');
    if (!footer) return;
    const observer = new IntersectionObserver(
      ([entry]) => setFooterVisible(entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(footer);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className="sticky-bar"
      style={{ opacity: footerVisible ? 0 : 1, pointerEvents: footerVisible ? 'none' : 'auto' }}
      role="complementary"
      aria-label="Konverzná lišta"
    >
      <div className="sticky-bar-inner">
        <div className="sticky-left">
          <span className="sticky-star-mark" aria-hidden="true">✦</span>
          Prvý návrh zdarma · Spustenie do 7 dní
        </div>
        <div className="sticky-center">
          <div className="sticky-stars" aria-label="5 hviezdičiek">
            {[...Array(5)].map((_, i) => <StarIcon key={i} />)}
          </div>
          <span>50+ spokojných klientov</span>
        </div>
        <div className="sticky-right">
          <button className="btn-primary sticky-cta" onClick={onAnalysisClick}>
            Chcem návrh →
          </button>
        </div>
      </div>
    </div>
  );
}
